/* export const DOMAIN_NAME = 'ExtraOutput'
export const PAGE = `${DOMAIN_NAME}.Similarity`
export const TITLE = `${PAGE}.TITLE` */

export const TITLE_PAGE = 'Similarity'
